import { Component, OnInit, AfterViewInit, ViewChildren } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { AppdataService } from 'src/app/services/services/appdata.service';
import { LoginserviceService } from 'src/app/services/services/loginservice.service';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
@Component({
  selector: 'app-addreason',
  templateUrl: './addreason.component.html',
  styleUrls: ['./addreason.component.css']
})
export class AddreasonComponent implements OnInit, AfterViewInit {

  @ViewChildren('input') firstipcontrol;

  formname: String = "Reason";

  //Display
  formmode: string = "Add";

  //Mode Values
  isaddmode: boolean = false;
  iseditmode: boolean = false;
  isdeletemode: boolean = false;
  isviewmode: boolean = false;

  isloading: boolean = false;
  isprivilage: boolean = false;
  showProgress: boolean = false;

  //Save Validation
  submitted: boolean;
  successfully: boolean;
  saveloading: boolean;

  //Edit Get Values
  reasonColl: any = [];
  reasonBO: any = {};

  reasonid: number = 0

  reasonform = new FormGroup({
    reasonid: new FormControl(0),
    reasonname: new FormControl('', Validators.required),
    inactive: new FormControl(false),
  });


  constructor(private appService: AppdataService, private loginService: LoginserviceService, private route: ActivatedRoute,
    public router: Router, private toastr: ToastrService, private productFindService: NgbModal) {
    this.route.queryParams.subscribe(params => {
      if (params.id !== undefined) {
        this.reasonid = params.id
      }
    });

    this.fnServiceChanges();
  }


  fnServiceChanges() {
    this.loginService.serviceAuthChange.subscribe((value) => {
      if (this.loginService.fnCheckCompany()) {
        if (this.fnCheckUserPririvilage()) {
          this.isloading = true;
          this.fnOnInitForm();
        }
        else {
          this.fnUserFailedForm();
        }
      }
      else {
        this.fnUserFailedForm();
      }


    });
  }


  ngOnInit() {
    try {
      if (this.loginService.fnCheckCompany()) {
        if (this.fnCheckUserPririvilage()) {
          this.isloading = true;
          this.fnOnInitForm();
        }
        else {
          this.fnUserFailedForm();
        }
      }
      else {
        this.loginService.fnGetUserRoleList();
      }

    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }

  fnOnInitForm() {
    try {
      this.isaddmode = true;
      this.reasonform.reset();
      this.fnInitializeFormGroup();

      if (this.reasonid > 0) {
        this.fngetReason();
      }
    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }

  fnCheckUserPririvilage() {
    var _check: boolean = false;
    if (this.reasonid > 0) {
      _check = this.loginService.fnCheckUserRoleAction(this.formname, 'ALTER')
    } else {
      _check = this.loginService.fnCheckUserRoleAction(this.formname, 'CREATE')
    }

    return _check;
  }

  fnUserFailedForm() {
    this.isprivilage = true;
  }

  ngAfterViewInit()
  {
    this.loginService.fnSetFirstControlFocus('txtfirst');
  }

  fnInitializeFormGroup() {
    this.reasonform.setValue({
      reasonid: 0,
      reasonname: '',
      inactive: false
    })
  }

  //Get 
  fngetReason() {

    if (this.showProgress) {
      return;
    }

    this.fnShowProgress();
    var data = {
      'reasonid': this.reasonid,
      'companyid': this.loginService.fnGetCompanyId()
    }
    this.appService.getReason(data)
      .subscribe(
        (res) => {
          if (res.json().status === 200) {
            this.fnHideProgress();
            this.reasonColl = res.json().result;
            var editdata = this.reasonColl[0];
            this.fnEditMode(editdata);
            this.reasonBO=editdata;
          }
          else {
            this.fnHideProgress();
            this.loginService.fnAPIError(res.json())
          }

        },
        (err) => {
          this.fnHideProgress();
          this.toastr.error('Error', err);
        })
  }



  //Save Btn Click
  fnSaveBtnClick() {
    try {
      if (this.saveloading) {
        return;
      }

      this.submitted = true;
      this.successfully = false;
      //Validate
      if (this.reasonform.valid) {
        //Check
        this.saveloading = true;


        var data = {
          'reasonid': this.reasonid,
          'reasonname': this.reasonform.get('reasonname').value,
          'inactive': this.reasonform.get('inactive').value,
          'companyid': this.loginService.fnGetCompanyId(),
          'createdby': this.loginService.fnGetModUserId(),
          'modifiedby': this.loginService.fnGetModUserId(),
        }


        this.appService.fnCheckReason(data).subscribe(
          (res) => {
            if (res.json().status === 200) {
              var _checkresult = res.json().result[0].checkfield;

              if (_checkresult === "done") {
                if (this.reasonform.get('reasonid').value > 0) {
                  //Update 
                  this.fnSetReason(data);
                }
                else {
                  //Insert 
                  this.fnInsertReason(data);
                }
              }
              else {
                if (_checkresult === "name") { this.saveloading = false;

                  this.reasonform.controls['reasonname'].setErrors({ 'notfound': true });
                }
              }
            }
            else { this.saveloading = false;

              this.loginService.fnAPIError(res.json())
            }
          },
          (err) => { this.saveloading = false;

            this.toastr.error('Error', err);
          });
      }
    } catch (ex) { this.saveloading = false;

      this.fnShowErrorMsg(ex);
    }
  }

  //Insert
  fnInsertReason(data) {

    this.appService.fnInsertReason(data).subscribe(
      (res) => { this.saveloading = false;

        if (res.json().status === 200) {
          if (res.json().result != "") {
            this.toastr.success('', "The new Reason has been added successfully.Insert Successfully");
            this.fnInsertActivityLog('INSERT', 0, data.reasonname);
            this.fnCloseForm();
          }
        }
        else {
          this.loginService.fnAPIError(res.json())
        }
      },
      (err) => { this.saveloading = false;

        this.toastr.error('Error', err);
      });

  }

  //Set
  fnSetReason(data) {

    this.appService.fnSetReason(data).subscribe(
      (res) => { this.saveloading = false;

        if (res.json().status === 200) {
          if (res.json().result != "") {
            this.toastr.success('', "The Reason has been updated successfully.");
            this.fnInsertActivityLog('EDIT', this.reasonid, data.reasonname);
            this.fnCloseForm();
          }
        }
        else {
          this.loginService.fnAPIError(res.json())
        }
      },
      (err) => { this.saveloading = false;

        this.toastr.error('Error', err);
      });

  }

  //Close
  fnCloseForm() {
    try {
      this.router.navigate(['/Reason']);
    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }

  private fnEditMode(deptBO) {
    this.reasonform.setValue({
      reasonid: deptBO.reasonid,
      reasonname: deptBO.reasonname,
      inactive: deptBO.inactive
    });

    this.formmode = "Edit";

    this.iseditmode = true;
    this.isdeletemode = false;
    this.isviewmode = false;
  }

  fnInsertActivityLog(action, refno, desc) {
    try {
      var data = {
        logtype: action,
        logat: this.formname,
        refnum: refno,
        logdescr: desc,
        logby: this.loginService.fnGetModUserId(),
      }


      this.appService.fnInsertActivity(data).subscribe(
        (res) => {
        },
        (err) => {

        });

    } catch{

    }
  }



  private fnShowProgress() {
    this.showProgress = true;
  }
  private fnHideProgress() {
    this.showProgress = false;
  }



  private fnShowErrorMsg(ex) {
    this.toastr.warning('Internal Error', ex);
  }







}
